import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }

      try {
        const userData = await exchangeSession(sessionId);
        // Clear the hash and navigate based on role
        window.history.replaceState(null, '', window.location.pathname);
        
        // Superadmin goes to superadmin panel, others to dashboard
        const targetPath = userData?.role === 'superadmin' ? '/superadmin' : '/dashboard';
        navigate(targetPath, { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/', { 
          replace: true, 
          state: { error: error.message } 
        });
      }
    };

    processAuth();
  }, [location.hash, exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
        <p className="text-lg text-muted-foreground">Giriş yapılıyor...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
